<div>
    <!-- <div   style="float:right;margin-top:5%;font-size:11px" >
        <button  class="btn btn-link shadow-none need" (click)="hotlineSubmit()">{{'Need help with Online diagnosis'|translate}}</button>
    </div> -->
    <div class="symptomheader">
        
        <b>{{'Symptoms Selected'|translate}} : {{symptomsSelected}}</b> &nbsp; <button [disabled]="symptomsSelected==0"
            (click)="procedureApi('')">{{'Continue'|translate}}</button> <br>
        <b>{{'If you are unable to select symptoms at this time'|translate}}, </b> <a  (click)="procedureApi('continue')"  class="btn-link1 s"> <b>{{'Click here to continue'|translate}}.</b></a>
    </div>
    <div  style="font-size: 0.80em; width: 85%; margin-left: 60px;">
            <span style="font-size: 0.80em;">
    <!-- <div class="holder" style="font-size: 0.80em"> -->
        <a class="btn btn-link shadow-none" routerLink="/symptoms" (click)="crumbArrowFirst()" style="font-size: 0.80rem; padding-left: 0px;"> {{'Start'|translate}}</a>
        <!-- <span *ngFor="let i of  symptomSelectedFirstName
        "> -->
        <!-- <button *ngIf="isAvailable" class="btn btn-link" routerLink="/symptoms" (click)="crumbArrowSecond()"> {{symptomSelectedFirstName}}</button> -->
        <!-- </span> -->
    </span>
    <span>
        <img *ngIf="isShowLink != '' && isShowLink != null" style="margin-left: -14px;" src="assets/images/crumb.png" width="23" height="14">
        <button
         *ngIf="!isHideLink && !isShowText" class="btn btn-link shadow-none s size1" (click)="crumbArrowSecond()" style="font-size: 0.80rem;" style="margin-left: -14px; vertical-align: middle;">{{isShowLink}}</button>
        <span class="symtoms-accesories1" style="margin-left: -3px; vertical-align: middle;" *ngIf="isShowText">{{isShowLink}}</span>
    </span>
    <span>
        <img style="margin-left: -14px;" *ngIf="isShowLink1 != '' && isShowLink1 != null" src="assets/images/crumb.png" width="23" height="14">
        <button *ngIf="!isHideLink1 && !isShowText1" class="btn btn-link shadow-none s size1" (click)="crumbArrowThird()" style="margin-left: -14px; vertical-align: middle;">{{isShowLink1}}</button>
    </span><span><span style="margin-left: -3px;" [ngClass]="isCrumb?'symptoms-accesories':'symptom-crumb'" class="symptoms-accesories" *ngIf="isShowText1" style="font-size: 0.80rem; vertical-align: middle;">{{isShowLink1}}</span>
        <img  style="margin-left: -14px;" *ngIf="isShowLink2 != '' && isShowLink2 != null" src="assets/images/crumb.png" width="23" height="14">
        <button *ngIf="!isHideLink2 && !isShowText2" class="btn btn-link shadow-none s size1" (click)="crumbArrowFourth()" style="margin-left: -14px; vertical-align: middle;">{{isShowLink2}}</button>
    </span> <span><span style="margin-left: -3px; vertical-align: middle;" class="symptoms-accesories" 
 *ngIf="isShowText2">{{isShowLink2}}</span>
        <img style="margin-left: -14px;"*ngIf="isShowLink3 != '' && isShowLink3 != null" src="assets/images/crumb.png" width="23"
            height="14"><button *ngIf="!isHideLink3 && !isShowText3" class="btn btn-link shadow-none s size1"
            (click)="crumbArrowFifth()" style="margin-left: -14px; vertical-align: middle;">{{isShowLink3}}</button>
        </span>  <span>   <span class="symptoms-accesories" style="margin-left: -3px; vertical-align: middle;" *ngIf="isShowText3">{{isShowLink3}}</span>
        <img style="margin-left: -14px;" *ngIf="isShowLink4 != '' && isShowLink4 != null" src="assets/images/crumb.png" width="23"
            height="14"><button *ngIf="!isHideLink4 && !isShowText4" class="btn btn-link shadow-none s size1"
            (click)="crumbArrowSixth()" style="margin-left: -14px; vertical-align: middle;">{{isShowLink4}}</button>
    </span><span><span class="symptoms-accesories" style="margin-left: -3px; vertical-align: middle;" style="
margin-left: 477px; vertical-align: middle;
" *ngIf="isShowText4">{{isShowLink4}}</span>
        <img style="margin-left: -14px;" *ngIf="isShowLink5 != '' && isShowLink5 != null" src="assets/images/crumb.png" width="23"
            height="14"><button *ngIf="!isHideLink5 && !isShowText5" class="btn btn-link shadow-none s size1"
            (click)="crumbArrowThird()" style="margin-left: -14px; vertical-align: middle;">{{isShowLink5}}</button>
    </span><span>   <span style="margin-left: -3px;" class="symptoms-accesories" style="
margin-left: 489px; vertical-align: middle;
" *ngIf="isShowText5">{{isShowLink5}}</span>
    </span> 

        <!-- <button *ngIf="!isHideLink2" class="btn btn-link" (clickl)="thirdChildnode()" ><img *ngIf="isShowLink2 != '' && isShowLink2 != null" src="assets/images/crumb.gif"   width="23" height="14">{{isShowLink2}}</button> -->
    <!-- </div> -->
</div>
</div>

<div style="width:90%;margin-left:5%;margin-top:2%" *ngIf="!showLoader">
    <ng-container
        *ngIf="!isShowChildNodes && !isShowChildNodes1 && !isShowChildNodes2 && !isShowChildNodes3 && !isShowChildNodes4 && !isShowChildNodes5 ">
        <div style="display: inline-block;" id="symptoms" *ngFor="let i of a;let ii=index">
            <div style="position: relative;">
            <div [class.colorclass]="parentIdList.includes(i.symptomId)"
                (click)="firstChildNode(i.symptomId,i.childNode,i.symptomName,i.parentId)" class="box">{{i.symptomName}}
                <img src="assets/images/symptoms.png" *ngIf="i.childNode.length>0" class="plus"
            >
            </div>
            </div>
        </div>
    </ng-container>

    <ng-container
        *ngIf="isShowChildNodes && !isShowChildNodes1 && !isShowChildNodes2 && !isShowChildNodes3 && !isShowChildNodes4 && !isShowChildNodes5">
        <div style="display: inline-block;" id="symptoms" *ngFor="let i of childList;let ii=index">
            <div style="position: relative;">
            <div [class.colorclass]="parentIdList.includes(i.symptomId)"
                (click)="secondChildNode(i.symptomId,i.childNode,i.symptomName,i.parentId)" class="box">{{i.symptomName}}
                <img src="assets/images/symptoms.png" *ngIf="i.childNode.length>0" class="plus"
            >
            </div>
            </div>
        </div>
    </ng-container>
    <ng-container
        *ngIf="isShowChildNodes1 && !isShowChildNodes && !isShowChildNodes2 && !isShowChildNodes3 && !isShowChildNodes4 && !isShowChildNodes5">
        <div style="display: inline-block;" id="symptoms" *ngFor="let i of childList1 ;let ii=index">
            <div style="position: relative;">
            <div [class.colorclass]="parentIdList.includes(i.symptomId)"
                (click)="thirdChildNode(ii,i.symptomId,i.childNode,i.symptomName,i.parentId)" class="box">{{i.symptomName}}
                <img src="assets/images/symptoms.png" *ngIf="i.childNode.length>0" class="plus"
            >
            </div>
            </div>
        </div>
    </ng-container>

    <ng-container
        *ngIf="isShowChildNodes2 &&  !isShowChildNodes &&  !isShowChildNodes1 && !isShowChildNodes3 && !isShowChildNodes4 && !isShowChildNodes5">
        <div style="display: inline-block;" id="symptoms" *ngFor="let i of childList2 ">
            <div style="position: relative;">
            <div [class.colorclass]="parentIdList.includes(i.symptomId)"
                (click)="fourthChildNode(i.symptomId,i.childNode,i.symptomName,i.parentId)" class="box">{{i.symptomName}}
                <img src="assets/images/symptoms.png" *ngIf="i.childNode.length>0" class="plus"
            >
            </div>
            </div>
        </div>
    </ng-container>

    <ng-container
        *ngIf="isShowChildNodes3 &&  !isShowChildNodes &&  !isShowChildNodes1 && !isShowChildNodes2 && !isShowChildNodes4 && !isShowChildNodes5">
        <div style="display: inline-block;" id="symptoms" *ngFor="let i of childList3 ">
            <div style="position: relative;">
            <div [class.colorclass]="parentIdList.includes(i.symptomId)"
                (click)="fifthChildNode(i.symptomId,i.childNode,i.symptomName,i.parentId)" class="box">{{i.symptomName}}
                <img src="assets/images/symptoms.png" *ngIf="i.childNode.length>0" class="plus"
            >
            </div>
            </div>
        </div>
    </ng-container>

    <ng-container
        *ngIf="isShowChildNodes4 &&  !isShowChildNodes &&  !isShowChildNodes1 && !isShowChildNodes3 && !isShowChildNodes2 && !isShowChildNodes5">
        <div style="display: inline-block;" id="symptoms" *ngFor="let i of childList4 ">
            <div style="position: relative;">
            <div [class.colorclass]="parentIdList.includes(i.symptomId)"
                (click)="sixthChildNode(i.symptomId,i.childNode,i.symptomName,i.parentId)" class="box">{{i.symptomName}}
                <img src="assets/images/symptoms.png" *ngIf="i.childNode.length>0" class="plus"
            >
            </div>
            </div>
        </div>
    </ng-container>


<div  style="text-align: center;" *ngIf="showArrow">
        <img src="assets/images/up.gif"  (click)="arrowFunction()" width="30" height="30">
    </div>

</div>


<div  style="text-align:center; margin-top:5%" *ngIf="showLoader">
   <b> {{'Symptom evaluation will now be performed'|translate}}</b>
    <div><img src="assets/images/ajax-loader.gif" alt="Loading" width="100" height="100"></div>
</div>
<div id="overlay" *ngIf="getDiagnosticCandidate">
    <span id="nav-spinner">
      <img src="assets/images/ajax-loader.gif" width="80" height="80">
    </span>
</div>